import { combine, withContext } from 'react-hooks-combine'
import { withRouter } from 'react-router'
import { StoreContext } from 'store/context'
import { profile } from 'routes/route.map'
import fp from 'lodash/fp'

import AddressInfoComponent from './component'

export default combine({
	hocs: [withRouter],
	hooks: [
		withContext('appConfig', StoreContext, ({ appConfig }) => appConfig),
	],
	transformProps: ({ appConfig, history }) => ({
		onClick: () => {
			// Check if mobile (phones breakpoint: 767px)
			const isMobile = window.innerWidth <= 767

			if (isMobile) {
				// Mobile: Navigate to new page
				history.push(profile.address())
			} else {
				// Desktop/Tablet: Open drawer
				appConfig.toggleDrawer('addressData')
			}
		},
	}),
})(AddressInfoComponent) 